import { render } from "./Header.vue?vue&type=template&id=74cff8a1&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=74cff8a1&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-74cff8a1"

export default script